import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'

import { Compensations } from 'modules/contracts/store/collections/compensations'

export interface AdditionalCompensationsContractData {
  loading: boolean
  additionalCompensations: Compensations
}

const useFetchAdditionalCompensations = (
  contractVersionIds: number[] | undefined
): AdditionalCompensationsContractData => {
  const additionalCompensations = useLazyRef(() => new Compensations()).current
  const { loading } = useAsyncData(async () => {
    const promises = []
    if (contractVersionIds)
      promises.push(
        additionalCompensations.fetch({
          data: {
            contract_version_ids: contractVersionIds,
          },
        })
      )
    return Promise.all(promises)
  }, [contractVersionIds?.join()])

  return {
    loading,
    additionalCompensations,
  }
}

export default useFetchAdditionalCompensations
